import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {Equipement} from 'app/models/equipement.model';
import {PieceEquipement} from '../../../../models/pieceEquipement.model';
import {Piece} from '../../../../models/piece.model';
import {EquipementService} from '../../../../services/equipement.service';
import {User} from '../../../../models/user.model';
import {DossierInterventionService} from '../../../../services/dossier_intervention.service';
import {UserService} from '../../../../services/user.service';

@Component({
    selector: 'app-modal-equipement-v2',
    templateUrl: './modal-equipement-v2.component.html'
})
export class ModalEquipementV2Component implements OnInit {
    @Input() idDossierIntervention: number;
    @Input() pieceEquipement: PieceEquipement = new PieceEquipement();

    success: boolean = false;
    error: boolean = false;
    equipements: Array<Equipement> = [];
    pieces: Array<Piece> = [];
    techniciens: Array<User> = [];
    equipementForm: FormGroup;

    get equipementsAutofill(): Array<Equipement> {
        if (!this.equipementForm.value?.equipement_id) {
            return this.equipements;
        }
        return this.equipements.filter(equipement => equipement?.no_equipement.toLowerCase().includes(this.equipementForm.value?.equipement_id?.toLowerCase()));
    }


    constructor(
        private equipementService: EquipementService,
        private dossierInterventionService: DossierInterventionService,
        private userService: UserService,
        public dialogRef: MatDialogRef<ModalEquipementV2Component>,
    ) {
    }

    ngOnInit(): void {
        this.equipementForm = new FormGroup({
            id: new FormControl(this.pieceEquipement.id),
            equipement_id: new FormControl(this.pieceEquipement.equipement?.no_equipement, [Validators.required]),
            piece_id: new FormControl(this.pieceEquipement.piece_id, [Validators.required]),
            date_installation: new FormControl(this.pieceEquipement.date_installation, [Validators.required]),
            heuredh: new FormControl(this.pieceEquipement.heuredh),
            date_recuperation: new FormControl(this.pieceEquipement.date_recuperation),
            user_id: new FormControl(this.pieceEquipement.user_id)
        });

        this.fetchAll();
    }

    fetchAll(): void {
        this.fetchEquipements();
        this.fetchPieces();
        this.fetchTechnicients();
    }

    fetchEquipements(): void {
        this.equipementService.getEquipements().subscribe((equipements) => {
            this.equipements = equipements;
        });
    }

    fetchPieces(): void {
        this.dossierInterventionService.getPiecesForDossierIntervention(this.idDossierIntervention).subscribe((pieces) => {
            this.pieces = pieces;
        });
    }

    fetchTechnicients(): void {
        this.userService.getUsers().subscribe((techniciens) => {
            this.techniciens = techniciens;
        });
    }

    onFormSubmit(): void {
        this.error = false;
        this.success = false;
        this.equipementForm.markAllAsTouched();

        if (this.equipementForm.valid) {
          const pieceEquipement = new PieceEquipement(this.equipementForm.value);

          pieceEquipement.equipement_id = this.equipements.find(equipement => equipement.no_equipement.toString() === pieceEquipement.equipement_id.toString())?.id;

          if(!pieceEquipement.equipement_id) {
           this.equipementForm.controls['equipement_id'].setErrors({ 'invalid': true });
          }

          if (pieceEquipement.id === null) {
              this.dossierInterventionService.storePieceEquipementForDossierIntervention(this.idDossierIntervention, pieceEquipement).subscribe(
                  (response) => {
                      this.success = true;
                      this.dialogRef.close(response);
                  }, (error) => { this.error = true; }
              );
          } else {
              this.dossierInterventionService.updatePieceEquipementForDossierIntervention(this.idDossierIntervention, pieceEquipement).subscribe(
                  (response) => {
                      this.success = true;
                      this.dialogRef.close(response);
                  }, (error) => { this.error = true; }
              );
          }

        }
    }
}
